export default __webpack_public_path__ + "static/media/dummy_image.3c0a422b.jpeg";